// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItem-cls1_BG5","cls2":"CreateSocialItem-cls2_ojT CreateSocialItem-cls1_BG5"};